/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: vjwl8iKCk0Vg
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicSeparatorHorizontal.module.css"; // plasmic-import: vjwl8iKCk0Vg/css

createPlasmicElementProxy;

export const PlasmicSeparatorHorizontal__VariantProps = new Array();

export const PlasmicSeparatorHorizontal__ArgProps = new Array();

const $$ = {};

function PlasmicSeparatorHorizontal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"separatorHorizontal"}
      data-plasmic-override={overrides.separatorHorizontal}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.separatorHorizontal
      )}
    />
  );
}

const PlasmicDescendants = {
  separatorHorizontal: ["separatorHorizontal"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSeparatorHorizontal__ArgProps,
          internalVariantPropNames: PlasmicSeparatorHorizontal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSeparatorHorizontal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "separatorHorizontal") {
    func.displayName = "PlasmicSeparatorHorizontal";
  } else {
    func.displayName = `PlasmicSeparatorHorizontal.${nodeName}`;
  }
  return func;
}

export const PlasmicSeparatorHorizontal = Object.assign(
  // Top-level PlasmicSeparatorHorizontal renders the root element
  makeNodeComponent("separatorHorizontal"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicSeparatorHorizontal
    internalVariantProps: PlasmicSeparatorHorizontal__VariantProps,
    internalArgProps: PlasmicSeparatorHorizontal__ArgProps
  }
);

export default PlasmicSeparatorHorizontal;
/* prettier-ignore-end */
